export default "__VITE_ASSET__wo4z5mvi__"